'use client';

const Arrow = ({
  direction,
  label,
  disabled,
  className,
  onClick,
}: ArrowProps) => {
  const isPrev = direction === 'prev';

  return (
    <button
      type="button"
      aria-label={label}
      disabled={disabled}
      onClick={onClick}
      className={[
        className,
        'absolute z-10 top-1/2 -translate-y-1/2 cursor-pointer',
        'h-[50px] w-[50px] rounded-full',
        'flex items-center justify-center',
        'bg-surface border border-black/10',
        'shadow-[0_5px_15px_#00000069]',
        'transition-all duration-200 ease-out',
        'hover:bg-white/80 hover:shadow-[0_8px_18px_rgba(0,0,0,0.18)] hover:scale-[1.03]',
        'active:scale-[0.97]',
        'disabled:opacity-30 disabled:shadow-none disabled:cursor-default disabled:hover:scale-100 disabled:bg-white/80',
      ].join(' ')}
    >
      <span
        className={[
          'block h-[10px] w-[10px]',
          'border-r-2 border-b-2',
          disabled ? 'border-primary' : '',
          isPrev ? 'rotate-[135deg]' : 'rotate-[-45deg]',
        ].join(' ')}
      />
    </button>
  );
};

export default Arrow;

type ArrowProps = {
  direction: 'prev' | 'next';
  label: string;
  disabled?: boolean;
  className?: string;
  onClick?: () => void;
};
